// app/javascript/controllers/index.js

import { application } from "./application"
import DisclosureController from "./disclosure_controller"
import DismissController from "./dismiss_controller"
import HeaderController from "./header_controller"
import ModalController from "./modal_controller"
import ParallaxController from "./parallax_controller"

application.register("disclosure", DisclosureController)
application.register("dismiss", DismissController)
application.register("header", HeaderController)
application.register("modal", ModalController)
application.register("parallax", ParallaxController)
